import { LinkButton } from '@flippingbook/web.react-kit/dist/Button';

import { loc } from '@/localization';
import { analyticsService } from '@/services/instance/analytics';
import { getProviderUrl } from '@/utils/getProviderUrl';

import facebookIcon from './assets/facebook.svg';
import googleIcon from './assets/google.svg';
import { e } from './style.css';

const onGoogleClick = () => analyticsService.sendExternalLoginButtonClick('google');
const onFacebookClick = () => analyticsService.sendExternalLoginButtonClick('facebook');

export function ExternalLoginButtons() {
    return (
        <div className={e.externalLoginButtons}>
            <LinkButton
                className={e.externalLoginButton}
                href={getProviderUrl('google')}
                onClick={onGoogleClick}
                size="large"
                theme="black"
                variant="outline"
                startIcon={
                    <img
                        className={e.buttonIcon}
                        src={googleIcon}
                        alt="Google"
                    />
                }
            >
                {loc.Login.LogInWith} Google
            </LinkButton>
            <LinkButton
                className={e.externalLoginButton}
                href={getProviderUrl('facebook')}
                onClick={onFacebookClick}
                size="large"
                theme="black"
                variant="outline"
                startIcon={
                    <img
                        className={e.buttonIcon}
                        src={facebookIcon}
                        alt="Facebook"
                    />
                }
            >
                {loc.Login.LogInWith} Facebook
            </LinkButton>
        </div>
    );
}
